module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-background-hack"
  }, [_c('HomeDirect')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fb58b16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SideProjectFarmClub.vue
// module id = 407
// module chunks = 1